import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {


    return (
        <footer
            className="bg-light text-center text-lg-start mt-auto w-100"
            style={{ minHeight: '20vh', position: 'relative', bottom: 0, left: 0 }}
        >
            <div className="container p-3">
                <div className="row">
                    <div className="col-md-4 mb-3 mb-md-0">
                        <h6 className="text-uppercase">About Us</h6>
                        <p className="text-muted mb-0">
                            We help you achieve your financial goals with expert advice and tools.
                        </p>
                    </div>
                    <div className="col-md-4 mb-3 mb-md-0">
                        <h6 className="text-uppercase">Resources</h6>
                        <ul className="list-unstyled mb-0">
                            <li>
                                <Link className="text-decoration-none text-dark" to="/blog">Blog</Link>
                            </li>
                           <li>
                                <Link className="text-decoration-none text-dark" to="/calculator">Calculators</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-4">
                        <h6 className="text-uppercase">Contact Us</h6>
                        <ul className="list-unstyled mb-0">
                            <li>
                                <a className="text-decoration-none text-dark" href="mailto:info@buildfinancegoals.com">info@buildfinancegoals.com</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <hr className="my-3" />
                <div className="text-center">
                    <span className="text-muted">
                        © 2025&nbsp;
                        <Link className="text-decoration-none text-dark" to="/">
                            buildfinancegoals.com
                        </Link>
                    </span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;